// Select all of the case study sliders on the page and loop through them
const navToggle = document.querySelector('#toggleMainNavigation');
if (navToggle) {
  navToggle.addEventListener('click', function (event) {
    let navigation = document.getElementById(this.getAttribute('aria-controls'));
    let body = document.querySelector('body');
    if (this.getAttribute('aria-expanded') == 'false') {
      navigation.classList.add('active');
      body.classList.add('noScroll');
      this.setAttribute('aria-expanded', 'true');
      this.setAttribute('aria-label', 'Close navigation');
      this.classList.add('is-active');
    } else {
      let activeMenus = document.querySelectorAll('.header nav .active');
      let activeButtons = document.querySelectorAll('.header nav button[aria-expanded=true]');
      activeMenus.forEach(menu => {
        menu.classList.remove('active');
      });
      activeButtons.forEach(button => {
        button.setAttribute('aria-expanded', false);
      });
      body.classList.remove('noScroll');
      this.setAttribute('aria-expanded', false);
      this.setAttribute('aria-label', 'Open navigation');
      this.classList.remove('is-active');
    }
  });
}

const subMenuButtons = document.querySelectorAll('#mainNavigation .menu-item--expanded button');
subMenuButtons.forEach(button => {
  let subMenu = button.nextElementSibling;
  button.addEventListener('click', function (event) {
    let expanded = button.getAttribute('aria-expanded') === 'true' || false;
    subMenu.classList.toggle('active');
    button.setAttribute('aria-expanded', !expanded);
  });
});

const breadcrumb = document.querySelector('section.breadcrumb.dynamic');
if (breadcrumb) {
  let firstSection = document.querySelector('article > div > .layout--onecol:first-child section');
  if (firstSection) {
    firstSection.after(breadcrumb);
    breadcrumb.classList.remove("dynamic");
  }
}

const stickCoursefinderElements = document.querySelectorAll('.sticky-coursefinder-form fieldset');

function hideCoursefinderElements() {
  stickCoursefinderElements.forEach((coursefinderElement) => {
    coursefinderElement.classList.add('collapse');
  });

}
const resetButton = document.querySelector('.sticky-coursefinder-form input[type="submit"][value="Reset"]');

if (resetButton) {
  resetButton.value = "Coursefinder Home"; // Change the button text
}

if (stickCoursefinderElements) {
  hideCoursefinderElements();
//  .classList.add('collapse');
  const coursefinderToggle = document.querySelectorAll('.sticky-coursefinder-form form > .input-group label, .sticky-coursefinder-form fieldset legend');


  coursefinderToggle.forEach((coursefinderElement) => {
    coursefinderElement.addEventListener('click', function (e) {
      // console.log(e.target.tagName.toLowerCase());
      if (e.target.tagName.toLowerCase() == 'label') {
        e.target.parentElement.classList.toggle('collapse');
      }
      if (e.target.tagName.toLowerCase() == 'span') {
        e.target.parentElement.parentElement.classList.toggle('collapse');
      }
    });
  });

  window.addEventListener("DOMContentLoaded", (event) => {
    const coursefinderMobileToggle = document.querySelector('.mobile-toggle');
    const stickyCoursefinderForm = document.querySelector('.sticky-coursefinder-form form');
    if (coursefinderMobileToggle && stickyCoursefinderForm) {
      coursefinderMobileToggle.addEventListener('click', function () {
        stickyCoursefinderForm.classList.toggle('show');
      });
    }
  });

  const coursefinderSelectAny = document.querySelectorAll('.sticky-coursefinder-form select, #views-exposed-form-progressions-only-coursefinder select');
  coursefinderSelectAny.forEach((coursefinderSelect) => {
    coursefinderSelect.addEventListener('click', function (e) {
      this.options[0].innerHTML = this.previousElementSibling.innerHTML + " (Any)";
    });
    coursefinderSelect.addEventListener('focusout', function (e) {
      this.options[0].innerHTML = this.previousElementSibling.innerHTML;
    });
  });
}

